import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import WordPressHero from '@/components/wordpress/WordPressHero';
import WhyAIPlugins from '@/components/wordpress/WhyAIPlugins';
import PluginShowcase from '@/components/wordpress/PluginShowcase';
import CustomPluginRequest from '@/components/wordpress/CustomPluginRequest';
import WordPressCTA from '@/components/wordpress/WordPressCTA';

const WordPressPlugins = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>AI-Powered WordPress Plugins Agent | Lovabuild</title>
        <meta
          name="description"
          content="Build or discover intelligent AI-powered WordPress plugins. Custom chatbots, automation, SEO optimization, and analytics solutions."
        />
        <meta
          name="keywords"
          content="AI WordPress plugins, custom WordPress development, WordPress chatbot, WordPress automation, AI SEO plugin"
        />
      </Helmet>

      <main>
        <WordPressHero />
        <WhyAIPlugins />
        <PluginShowcase />
        <CustomPluginRequest />
        <WordPressCTA />
      </main>
    </>
  );
};

export default WordPressPlugins;
